//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAuthClient {
    loginUser(userId: string): Observable<UserObj>;
    signOut(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthClient implements IAuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    loginUser(userId: string): Observable<UserObj> {
        let url_ = this.baseUrl + "/api/Auth/LoginUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserObj>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserObj>;
        }));
    }

    protected processLoginUser(response: HttpResponseBase): Observable<UserObj> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserObj.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    signOut(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Auth/SignOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processSignOut(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustomerManagementClient {
    insertService(serviceDto: ServicesDto): Observable<MessageOut>;
    insertTechnical(technicalDto: TechnicalsDto): Observable<MessageOut>;
    getAllServices(): Observable<ServicesDto[]>;
    getAllTechnicals(): Observable<TechnicalsDto[]>;
    getFinancialControls(search: string | null | undefined): Observable<FinancialControlDto[]>;
    getFinancialControlByServiceId(serviceId: number | undefined): Observable<FinancialControlDto>;
    getAllPartes(): Observable<PartesDto[]>;
    getParteById(id: number | undefined): Observable<PartesDto>;
    getParteImagenById(id: number | undefined): Observable<FileResponse>;
    updateService(serviceDto: ServicesDto): Observable<MessageOut>;
    updateTechnical(technicalDto: TechnicalsDto): Observable<MessageOut>;
    updateFinancialControl(financialControlDto: FinancialControlDto): Observable<MessageOut>;
    deleteService(serviceId: number): Observable<MessageOut>;
    deleteTechnical(technicalId: number): Observable<MessageOut>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerManagementClient implements ICustomerManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    insertService(serviceDto: ServicesDto): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/InsertService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processInsertService(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertTechnical(technicalDto: TechnicalsDto): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/InsertTechnical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technicalDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertTechnical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertTechnical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processInsertTechnical(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllServices(): Observable<ServicesDto[]> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetAllServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicesDto[]>;
        }));
    }

    protected processGetAllServices(response: HttpResponseBase): Observable<ServicesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServicesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllTechnicals(): Observable<TechnicalsDto[]> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetAllTechnicals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTechnicals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTechnicals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TechnicalsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TechnicalsDto[]>;
        }));
    }

    protected processGetAllTechnicals(response: HttpResponseBase): Observable<TechnicalsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TechnicalsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialControls(search: string | null | undefined): Observable<FinancialControlDto[]> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetFinancialControls?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialControls(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialControls(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialControlDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialControlDto[]>;
        }));
    }

    protected processGetFinancialControls(response: HttpResponseBase): Observable<FinancialControlDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialControlDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFinancialControlByServiceId(serviceId: number | undefined): Observable<FinancialControlDto> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetFinancialControlByServiceId?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialControlByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialControlByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialControlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialControlDto>;
        }));
    }

    protected processGetFinancialControlByServiceId(response: HttpResponseBase): Observable<FinancialControlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialControlDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllPartes(): Observable<PartesDto[]> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetAllPartes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPartes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPartes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartesDto[]>;
        }));
    }

    protected processGetAllPartes(response: HttpResponseBase): Observable<PartesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParteById(id: number | undefined): Observable<PartesDto> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetParteById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartesDto>;
        }));
    }

    protected processGetParteById(response: HttpResponseBase): Observable<PartesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getParteImagenById(id: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/CustomerManagement/GetParteImagenById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParteImagenById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParteImagenById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetParteImagenById(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateService(serviceDto: ServicesDto): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/UpdateService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processUpdateService(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateTechnical(technicalDto: TechnicalsDto): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/UpdateTechnical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technicalDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTechnical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTechnical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processUpdateTechnical(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFinancialControl(financialControlDto: FinancialControlDto): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/UpdateFinancialControl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(financialControlDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinancialControl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialControl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processUpdateFinancialControl(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteService(serviceId: number): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/DeleteService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processDeleteService(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteTechnical(technicalId: number): Observable<MessageOut> {
        let url_ = this.baseUrl + "/api/CustomerManagement/DeleteTechnical";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technicalId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTechnical(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTechnical(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageOut>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageOut>;
        }));
    }

    protected processDeleteTechnical(response: HttpResponseBase): Observable<MessageOut> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageOut.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class UserObj implements IUserObj {
    claims?: Claim[];
    accessToken?: string;

    constructor(data?: IUserObj) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): UserObj {
        data = typeof data === 'object' ? data : {};
        let result = new UserObj();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface IUserObj {
    claims?: Claim[];
    accessToken?: string;
}

export class Claim implements IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | undefined;
    type?: string;
    value?: string;
    valueType?: string;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : <any>undefined;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | undefined;
    type?: string;
    value?: string;
    valueType?: string;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType?: string | undefined;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | undefined;
    bootstrapContext?: any | undefined;
    claims?: Claim[];
    label?: string | undefined;
    name?: string | undefined;
    nameClaimType?: string;
    roleClaimType?: string;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : <any>undefined;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            this.label = _data["label"];
            this.name = _data["name"];
            this.nameClaimType = _data["nameClaimType"];
            this.roleClaimType = _data["roleClaimType"];
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["actor"] = this.actor ? this.actor.toJSON() : <any>undefined;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["name"] = this.name;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data;
    }
}

export interface IClaimsIdentity {
    authenticationType?: string | undefined;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | undefined;
    bootstrapContext?: any | undefined;
    claims?: Claim[];
    label?: string | undefined;
    name?: string | undefined;
    nameClaimType?: string;
    roleClaimType?: string;
}

export class MessageOut implements IMessageOut {
    messageOK?: string | undefined;
    messageError?: string | undefined;

    constructor(data?: IMessageOut) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageOK = _data["messageOK"];
            this.messageError = _data["messageError"];
        }
    }

    static fromJS(data: any): MessageOut {
        data = typeof data === 'object' ? data : {};
        let result = new MessageOut();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageOK"] = this.messageOK;
        data["messageError"] = this.messageError;
        return data;
    }
}

export interface IMessageOut {
    messageOK?: string | undefined;
    messageError?: string | undefined;
}

export class ServicesDto implements IServicesDto {
    seR_Id?: number;
    seR_Description?: string | undefined;
    seR_Expedient?: string | undefined;
    seR_Activity?: string | undefined;
    seR_Pr?: string | undefined;
    seR_Address?: string | undefined;
    seR_Poblation?: string | undefined;
    seR_PostalCode?: string | undefined;
    seR_TechnicalId?: number | undefined;
    seR_TechnicalName?: string | undefined;
    seR_Telephone?: string | undefined;
    seR_Import?: number | undefined;
    seR_ServiceDate?: Date | undefined;
    seR_Closed?: boolean | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    seR_Payed?: boolean | undefined;
    hasBeenVisited?: boolean | undefined;

    constructor(data?: IServicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seR_Id = _data["seR_Id"];
            this.seR_Description = _data["seR_Description"];
            this.seR_Expedient = _data["seR_Expedient"];
            this.seR_Activity = _data["seR_Activity"];
            this.seR_Pr = _data["seR_Pr"];
            this.seR_Address = _data["seR_Address"];
            this.seR_Poblation = _data["seR_Poblation"];
            this.seR_PostalCode = _data["seR_PostalCode"];
            this.seR_TechnicalId = _data["seR_TechnicalId"];
            this.seR_TechnicalName = _data["seR_TechnicalName"];
            this.seR_Telephone = _data["seR_Telephone"];
            this.seR_Import = _data["seR_Import"];
            this.seR_ServiceDate = _data["seR_ServiceDate"] ? new Date(_data["seR_ServiceDate"].toString()) : <any>undefined;
            this.seR_Closed = _data["seR_Closed"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.seR_Payed = _data["seR_Payed"];
            this.hasBeenVisited = _data["hasBeenVisited"];
        }
    }

    static fromJS(data: any): ServicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seR_Id"] = this.seR_Id;
        data["seR_Description"] = this.seR_Description;
        data["seR_Expedient"] = this.seR_Expedient;
        data["seR_Activity"] = this.seR_Activity;
        data["seR_Pr"] = this.seR_Pr;
        data["seR_Address"] = this.seR_Address;
        data["seR_Poblation"] = this.seR_Poblation;
        data["seR_PostalCode"] = this.seR_PostalCode;
        data["seR_TechnicalId"] = this.seR_TechnicalId;
        data["seR_TechnicalName"] = this.seR_TechnicalName;
        data["seR_Telephone"] = this.seR_Telephone;
        data["seR_Import"] = this.seR_Import;
        data["seR_ServiceDate"] = this.seR_ServiceDate ? this.seR_ServiceDate.toISOString() : <any>undefined;
        data["seR_Closed"] = this.seR_Closed;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["seR_Payed"] = this.seR_Payed;
        data["hasBeenVisited"] = this.hasBeenVisited;
        return data;
    }
}

export interface IServicesDto {
    seR_Id?: number;
    seR_Description?: string | undefined;
    seR_Expedient?: string | undefined;
    seR_Activity?: string | undefined;
    seR_Pr?: string | undefined;
    seR_Address?: string | undefined;
    seR_Poblation?: string | undefined;
    seR_PostalCode?: string | undefined;
    seR_TechnicalId?: number | undefined;
    seR_TechnicalName?: string | undefined;
    seR_Telephone?: string | undefined;
    seR_Import?: number | undefined;
    seR_ServiceDate?: Date | undefined;
    seR_Closed?: boolean | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    seR_Payed?: boolean | undefined;
    hasBeenVisited?: boolean | undefined;
}

export class TechnicalsDto implements ITechnicalsDto {
    teC_Id?: number;
    teC_Name?: string;
    teC_Email?: string | undefined;

    constructor(data?: ITechnicalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teC_Id = _data["teC_Id"];
            this.teC_Name = _data["teC_Name"];
            this.teC_Email = _data["teC_Email"];
        }
    }

    static fromJS(data: any): TechnicalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teC_Id"] = this.teC_Id;
        data["teC_Name"] = this.teC_Name;
        data["teC_Email"] = this.teC_Email;
        return data;
    }
}

export interface ITechnicalsDto {
    teC_Id?: number;
    teC_Name?: string;
    teC_Email?: string | undefined;
}

export class FinancialControlDto implements IFinancialControlDto {
    fC_Id?: number;
    fC_ServiceId?: number;
    fC_ServiceExpedient?: string | undefined;
    fC_TechnicalName?: string | undefined;
    fC_Labour?: number | undefined;
    fC_Material?: number | undefined;
    fC_AmountNoIVA?: number | undefined;
    fC_AmountWithIVA?: number | undefined;
    fC_PaymentToMapfre?: number | undefined;
    fC_PaymentToMapfreWithTaxes?: number | undefined;
    fC_Return?: number | undefined;
    fC_PaymentType?: string | undefined;
    fC_Payed?: boolean | undefined;
    fC_Discounted?: boolean | undefined;
    fC_Date?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;

    constructor(data?: IFinancialControlDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fC_Id = _data["fC_Id"];
            this.fC_ServiceId = _data["fC_ServiceId"];
            this.fC_ServiceExpedient = _data["fC_ServiceExpedient"];
            this.fC_TechnicalName = _data["fC_TechnicalName"];
            this.fC_Labour = _data["fC_Labour"];
            this.fC_Material = _data["fC_Material"];
            this.fC_AmountNoIVA = _data["fC_AmountNoIVA"];
            this.fC_AmountWithIVA = _data["fC_AmountWithIVA"];
            this.fC_PaymentToMapfre = _data["fC_PaymentToMapfre"];
            this.fC_PaymentToMapfreWithTaxes = _data["fC_PaymentToMapfreWithTaxes"];
            this.fC_Return = _data["fC_Return"];
            this.fC_PaymentType = _data["fC_PaymentType"];
            this.fC_Payed = _data["fC_Payed"];
            this.fC_Discounted = _data["fC_Discounted"];
            this.fC_Date = _data["fC_Date"] ? new Date(_data["fC_Date"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancialControlDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialControlDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fC_Id"] = this.fC_Id;
        data["fC_ServiceId"] = this.fC_ServiceId;
        data["fC_ServiceExpedient"] = this.fC_ServiceExpedient;
        data["fC_TechnicalName"] = this.fC_TechnicalName;
        data["fC_Labour"] = this.fC_Labour;
        data["fC_Material"] = this.fC_Material;
        data["fC_AmountNoIVA"] = this.fC_AmountNoIVA;
        data["fC_AmountWithIVA"] = this.fC_AmountWithIVA;
        data["fC_PaymentToMapfre"] = this.fC_PaymentToMapfre;
        data["fC_PaymentToMapfreWithTaxes"] = this.fC_PaymentToMapfreWithTaxes;
        data["fC_Return"] = this.fC_Return;
        data["fC_PaymentType"] = this.fC_PaymentType;
        data["fC_Payed"] = this.fC_Payed;
        data["fC_Discounted"] = this.fC_Discounted;
        data["fC_Date"] = this.fC_Date ? this.fC_Date.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFinancialControlDto {
    fC_Id?: number;
    fC_ServiceId?: number;
    fC_ServiceExpedient?: string | undefined;
    fC_TechnicalName?: string | undefined;
    fC_Labour?: number | undefined;
    fC_Material?: number | undefined;
    fC_AmountNoIVA?: number | undefined;
    fC_AmountWithIVA?: number | undefined;
    fC_PaymentToMapfre?: number | undefined;
    fC_PaymentToMapfreWithTaxes?: number | undefined;
    fC_Return?: number | undefined;
    fC_PaymentType?: string | undefined;
    fC_Payed?: boolean | undefined;
    fC_Discounted?: boolean | undefined;
    fC_Date?: Date | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
}

export class PartesDto implements IPartesDto {
    paR_Id?: number;
    paR_Description?: string | undefined;
    paR_Expedient?: string | undefined;
    paR_PaymentMethod?: string | undefined;
    paR_Price?: number | undefined;
    paR_BinaryFile?: string | undefined;
    paR_ContentFile?: string | undefined;
    paR_ExtensionFile?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    paR_TechicalId?: number;
    paR_TechnicalName?: string | undefined;

    constructor(data?: IPartesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paR_Id = _data["paR_Id"];
            this.paR_Description = _data["paR_Description"];
            this.paR_Expedient = _data["paR_Expedient"];
            this.paR_PaymentMethod = _data["paR_PaymentMethod"];
            this.paR_Price = _data["paR_Price"];
            this.paR_BinaryFile = _data["paR_BinaryFile"];
            this.paR_ContentFile = _data["paR_ContentFile"];
            this.paR_ExtensionFile = _data["paR_ExtensionFile"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.paR_TechicalId = _data["paR_TechicalId"];
            this.paR_TechnicalName = _data["paR_TechnicalName"];
        }
    }

    static fromJS(data: any): PartesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paR_Id"] = this.paR_Id;
        data["paR_Description"] = this.paR_Description;
        data["paR_Expedient"] = this.paR_Expedient;
        data["paR_PaymentMethod"] = this.paR_PaymentMethod;
        data["paR_Price"] = this.paR_Price;
        data["paR_BinaryFile"] = this.paR_BinaryFile;
        data["paR_ContentFile"] = this.paR_ContentFile;
        data["paR_ExtensionFile"] = this.paR_ExtensionFile;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["paR_TechicalId"] = this.paR_TechicalId;
        data["paR_TechnicalName"] = this.paR_TechnicalName;
        return data;
    }
}

export interface IPartesDto {
    paR_Id?: number;
    paR_Description?: string | undefined;
    paR_Expedient?: string | undefined;
    paR_PaymentMethod?: string | undefined;
    paR_Price?: number | undefined;
    paR_BinaryFile?: string | undefined;
    paR_ContentFile?: string | undefined;
    paR_ExtensionFile?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    updatedBy?: string | undefined;
    updatedDate?: Date | undefined;
    paR_TechicalId?: number;
    paR_TechnicalName?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}